// extracted by mini-css-extract-plugin
export default {"checkbox":"e_E5yT","checkboxError":"CzBPju"};